import { UserRoles } from '../../../components/roster/types';
import { type InviteStudentsResponse, type Student } from '../types/inviteStudentsTypes';

const blankStudent: Student = {
    firstName: '',
    lastName: '',
    email: '',
    role: UserRoles.Student // A blank student always defaults to being a student.
};

// If this becomes dynamic, move to context as state
const perPage = 10;

const initialStudentsReponse: InviteStudentsResponse = {
    status: 500,
    body: {
        error: 'initial'
    }
};

export { blankStudent, perPage, initialStudentsReponse };
